export const DEFAULT_VIEW = 'defaultView'
export const TEMPLATE_VIEW = 'templateView'
